export default __webpack_public_path__ + "ffc4019c553b2c420a6890edb8108209.png";